<template>
  <span>
    <div v-if="modalNewPlayer">
      <NewPlayerJoinedDialog
        v-bind:newPlayerNickname="modalNewPlayerNickname"
      />
    </div>
  </span>
</template>

<script>
import NewPlayerJoinedDialog from "@/components/NewPlayerJoinedDialog.vue";
import { mapGetters } from "vuex";

// Shows dialog if a new player joins and puts her on pause
export default {
  components: { NewPlayerJoinedDialog },
  data: function () {
    return {
      modalNewPlayer: false,
      modalNewPlayerNickname: "",
      numberOfPlayers: 0,
      playerIds: [],
    };
  },
  async mounted() {
    this.$store.dispatch(
        "log",
        "Created."
      );   

    this.numberOfPlayers = this.$store.state.main.allPlayers.length;
    this.updatePlayerIds();
    this.$store.dispatch(
        "log",
        "Installing close-new-player-dialog event listener."
      );      

    this.$bus.$on("close-new-player-dialog", () => {
      this.$store.dispatch(
        "log",
        "Received close-new-player-dialog dialog event."
      );      
      this.modalNewPlayer = false;
    });
  },
  beforeDestroy() {
    this.$bus.$off("close-new-player-dialog");
  },    
  computed: {
    ...mapGetters([
      "getPlayers"])
  },
  methods: {
    updatePlayerIds() {
      this.playerIds = [];
      for (let i = 0; i < this.$store.state.main.allPlayers.length; i++) {
        this.playerIds.push(this.$store.state.main.allPlayers[i].id);
      }
    },
  },
  watch: {
    getPlayers: {
      handler(newData, oldData) {
        // Let's check if a new player has joined
        const newPlayersCount = this.$store.state.main.allPlayers.length;

        if (
          this.$store.getters.getIsFacilitator &&
          !this.$store.state.main.playerIsObserver &&
          newPlayersCount > this.numberOfPlayers
        ) {
          // A new player has joined! Let's give the facilitator a heads-up and pause the new player.

          // Find out id of the new player:
          for (let i = 0; i < this.$store.state.main.allPlayers.length; i++) {
            const index = this.playerIds.findIndex(
              (id) => id === this.$store.state.main.allPlayers[i].id
            );

            if (index === -1) {
              // Index of new player, backend puts player on pause but let's show a modal
              this.modalNewPlayerNickname = this.$store.state.main.allPlayers[i].nick_name;
              this.modalNewPlayer = true;
              break;
            }
          }
        }
        this.updatePlayerIds();

        this.numberOfPlayers = newPlayersCount;
      },
      deep: true,
    },
  },
};
</script>
